import {VideoFileTimeline} from './timeline';

export class VideoFileClasses {
  id: string;
  name: string;
  title: string;
  timelines: VideoFileTimeline[];
  value: any;
}
